import { useQuery } from "@tanstack/react-query"
import { useGetBanksList } from "./useGetBanksList"
import { IBankMeta, PaymentToolType } from "../interface"
import { useGetPaymentToolsList } from "./useGetPaymentToolsList"

async function merge(
  bankIds: string[] | undefined,
  banksList: IBankMeta[],
) {
  if (!bankIds || !banksList) {
    throw new Error("Данные отсутствуют")
  }

  const foundBanks = banksList.filter((bank) =>
    bankIds.includes(bank.bankId),
  )

  if (!foundBanks) {
    throw new Error("Банк с указанным ID не найден")
  }

  return foundBanks
}

export const useGetLinkedBanksList = () => {
  const { data: paymentToolsListResponse } = useGetPaymentToolsList(0, 100, PaymentToolType.SBP_ACCOUNT)
  const { data: banksListData } = useGetBanksList(null)

  const bankIds = paymentToolsListResponse?.items.map(
    (item) => item.maskedValue,
  )

  return useQuery({
    queryKey: ["get-linked-banks-list", bankIds],
    queryFn: () => merge(bankIds, banksListData!.items), 
    enabled: Boolean(bankIds?.length && banksListData),
  })
}
